import { isValid, isDate } from 'date-fns';
import { sapFullDateTimeFormat } from 'constants/dateFormats';
import { formatISODate, formatDate } from './formatDate';

export const convertDateToISOFormat = (date, format = sapFullDateTimeFormat) => {
  if (!isDate(date)) {
    return '';
  }

  return formatISODate(date, format);
};

export const convertDateFormat = (date, format = sapFullDateTimeFormat) => {
  if (!date) {
    return '';
  }
  let dateObj = date;
  if (!isDate(date)) {
    dateObj = new Date(date);
  }
  if (!isValid(dateObj)) {
    return '';
  }

  return formatDate(dateObj, format);
};
